/*
 * Category Utilities
 *
 * Warning: Some of these utilities operate directly on the store. These bypass
 * the patterns used in Redux (e.g. connect) so should be used with caution.
 *
 */


import store from '../../store';
import { REDUCER_KEY } from './reducer';

import * as selectors from './selectors';
import * as actions from './actions';

/*
 * how we get store state.  "selectors" seem to work off the global store and reducer key.  It then
 * subsequently retrieves
 */
export function getSelectorStore() {
  return store.getState();
}
export function getCategoryState() {
  return store.getState()[REDUCER_KEY];
}

export function getCatByClientId(clientId) {
  const categories = selectors.getCategories(getSelectorStore());
  return categories.find((coa) => coa.clientId === clientId)
}

// Shortcuts to Selectors -----------------------------------------------------------

export function getCoaString(coa, noParent) {
  return selectors.getCoaStringSelector(getSelectorStore(), { coa, noParent });
}
export function getCategoryForId(id) {
  return selectors.getCategoryForId(getSelectorStore(), id);
}
export function isIncomeCat(id) {
  return selectors.isIncomeCat(getSelectorStore(), id);
}

export function isExpenseCat(id) {
  return selectors.isExpenseCat(getSelectorStore(), id);
}

// Access to Reducers (change state) via ACTIONS (TODO) -------------------------------------------------------------

export function getCategories() {
  return store.dispatch(actions.getCategories());
}
export function createCategory(data) {
  return store.dispatch(actions.createCategory(data));
}
export function updateCategory(data) {
  return store.dispatch(actions.updateCategory(data));
}
export function deleteCategory(data) {
  return store.dispatch(actions.deleteCategory(data));
}


